/**
 * Returns the convention-based profile icon URL for a roster entry.
 * Images are stored as public/{first8chars}_p.webp and deployed to the site root.
 * These are small (200×200) face-crop images suitable for circle avatars.
 */
export function rosterProfileIconUrl(rosterId: string): string {
  return `/${rosterId.substring(0, 8)}_p.webp`;
}
